import { useEffect, useRef } from "react";

/**
 * AdSense display ad slot.
 *
 * Usage:
 *   <AdSlot slot="1234567890" />          // responsive
 *   <AdSlot slot="1234567890" format="rectangle" />
 *
 * Get the `slot` number from AdSense → Ads → By ad unit → Display ads → Create.
 * Until you create your first ad unit, you can leave slot="" — the component
 * will render nothing, so the page stays clean.
 */
const CLIENT = "ca-pub-8282516711075397";

export default function AdSlot({ slot = "", format = "auto", layout = "", className = "" }) {
  const ref = useRef(null);

  useEffect(() => {
    if (!slot) return;
    try {
      // eslint-disable-next-line no-undef
      (window.adsbygoogle = window.adsbygoogle || []).push({});
    } catch {
      /* ignore — script may still be loading */
    }
  }, [slot]);

  if (!slot) return null; // graceful no-op until you create the ad unit

  return (
    <div className={`my-8 ${className}`} data-testid="adsense-slot">
      <ins
        ref={ref}
        className="adsbygoogle"
        style={{ display: "block" }}
        data-ad-client={CLIENT}
        data-ad-slot={slot}
        data-ad-format={format}
        data-full-width-responsive="true"
        {...(layout ? { "data-ad-layout": layout } : {})}
      />
      <div className="text-[10px] uppercase tracking-widest text-black/30 text-center mt-1 font-mono">advertisement</div>
    </div>
  );
}
